import { AdvancedTagMapping } from 'src/features/gateway-details/types';
import { CustomErrors } from '../types';
import { UseFormClearErrors } from 'react-hook-form';
import { MAX_VALUE_INVALID, MIN_VALUE_INVALID } from '../config';
import { validateMinusSign } from './validate-minus-sign';

export const validateMinMaxValueChange = (
  name: string,
  newValue: string,
  values: AdvancedTagMapping,
  customErrors: CustomErrors,
  setCustomErrors: React.Dispatch<React.SetStateAction<CustomErrors>>,
  clearCustomErrors: (name: string, specificErrorValue: string, clearEntireKey?: boolean) => void,
  clearErrors: UseFormClearErrors<AdvancedTagMapping>,
  newOppositeValue: string | null = null
) => {
  if (name === 'maxValue') {
    if (newValue !== '') {
      if (+newValue <= +(newOppositeValue ?? values.minValue)) {
        let messagesNew: string[] = [];
        const messages = customErrors.maxValue?.message;
        if (messages && !messages.includes(MAX_VALUE_INVALID)) {
          messages.push(MAX_VALUE_INVALID);
        } else if (!messagesNew.includes(MAX_VALUE_INVALID)) {
          messagesNew.push(MAX_VALUE_INVALID);
        }
        setCustomErrors((prevValue) => ({
          ...prevValue,
          [`maxValue`]: { message: messages ?? messagesNew },
        }));
      } else {
        clearCustomErrors('minValue', MIN_VALUE_INVALID);
        clearCustomErrors('maxValue', MAX_VALUE_INVALID);
      }
    } else {
      clearCustomErrors('maxValue', '', true);
    }
  } else if (name === 'minValue') {
    if (newValue !== '') {
      if (+newValue >= +(newOppositeValue ?? values.maxValue)) {
        const validationMessage = MIN_VALUE_INVALID;
        let messagesNew: string[] = [];
        const messages = customErrors.minValue?.message;
        if (messages && !messages.includes(validationMessage)) {
          messages.push(validationMessage);
        } else if (!messagesNew.includes(validationMessage)) {
          messagesNew.push(validationMessage);
        }
        setCustomErrors((prevValue) => ({
          ...prevValue,
          [`minValue`]: { message: messages ?? messagesNew },
        }));
      } else {
        clearCustomErrors('maxValue', MAX_VALUE_INVALID);
        clearCustomErrors('minValue', MIN_VALUE_INVALID);
      }
    } else {
      clearCustomErrors('minValue', '', true);
    }
  }

  validateMinusSign(newValue, name, customErrors, setCustomErrors, clearCustomErrors);

  if (newValue !== '') clearErrors(name);
};
